type GameweekHeaderProps = {
  gameweeks: number[];
  hiddenGameweeks?: number[];
  fixtureCellWidth: number;
  rowHeight: number;
  // When true, columns flex to fill the available width instead of using a
  // fixed pixel width (used by the homepage mini ticker, which has no scroll).
  stretch?: boolean;
  onToggleGameweek?: (gameweek: number) => void;
};

export const GameweekHeader = ({
  gameweeks,
  hiddenGameweeks = [],
  fixtureCellWidth,
  rowHeight,
  stretch = false,
  onToggleGameweek
}: GameweekHeaderProps) => (
  <div className={`flex gap-1 ${stretch ? 'flex-1' : ''}`}>
    {gameweeks.map((gameweek) => {
      const isHidden = hiddenGameweeks.includes(gameweek);

      return (
        <button
          key={gameweek}
          type="button"
          data-testid={`gameweek-header-${gameweek}`}
          aria-pressed={isHidden}
          title={
            onToggleGameweek
              ? isHidden
                ? `Show gameweek ${gameweek}`
                : `Hide gameweek ${gameweek}`
              : undefined
          }
          onClick={
            onToggleGameweek ? () => onToggleGameweek(gameweek) : undefined
          }
          disabled={!onToggleGameweek}
          className={`flex items-center justify-center text-xs font-semibold disabled:cursor-default ${
            stretch ? 'flex-1' : ''
          } ${isHidden ? 'text-neutral-300 line-through' : 'text-neutral-700'}`}
          style={
            stretch
              ? { height: rowHeight }
              : { width: fixtureCellWidth, height: rowHeight }
          }
        >
          {gameweek}
        </button>
      );
    })}
  </div>
);
